// Přidání tlačítek do DOM
if ($(".type-detail").length) {
  // 🟢 DETAIL PRODUKTU
  const codes = getShoptetDataLayer("product").codes || [];
  const ids = codes.map((c) => c.code);
  const productId = $('#product-detail-form meta[itemprop="productID"]').attr("content");
  $(".p-info-wrapper .social-buttons-wrapper").append(`
        <div class="customFavorite">
            <span class="add-to-favorites" data-id="${productId}" data-ids='${JSON.stringify(ids)}'>
                Přidat do oblíbených
            </span>
        </div>
    `);
}
// Pomocné funkce
function isUserLoggedIn() {
  if (typeof getShoptetDataLayer !== "function") return false;
  const customerData = getShoptetDataLayer("customer");
  return customerData && customerData.registered;
}

function getProjectId() {
  return getShoptetDataLayer("projectId");
}

function getFavoritesFromLocal(projectId) {
  let data = localStorage.getItem(`favorites-${projectId}`);
  return data ? JSON.parse(data) : [];
}

function saveFavoritesToLocal(projectId, data) {
  localStorage.setItem(`favorites-${projectId}`, JSON.stringify(data));
}

function normalizeOriginalImageSrc(src) {
  return (src || "").replace("/related/", "/orig/");
}

// Uložení nebo odebrání oblíbených
function toggleFavoritesBatch(productIds, productData, isRemoving, callback = null) {
  const projectId = getProjectId();

  if (isUserLoggedIn()) {
    const userId = getShoptetDataLayer("customer").guid;
    $.post(
      "https://oblibene.shopcode.cz/favorite.php",
      {
        action: isRemoving ? "remove" : "add",
        user_id: userId,
        shop_id: projectId,
        product_ids: productIds,
        product_data: JSON.stringify(productData),
      },
      function () {
        if (typeof callback === "function") callback(!isRemoving);
      },
    );
  } else {
    let favorites = getFavoritesFromLocal(projectId);
    if (isRemoving) {
      favorites = favorites.filter((f) => !productIds.includes(f.product_id));
    } else {
      productIds.forEach((id) => {
        if (!favorites.find((f) => f.product_id === id)) {
          favorites.push({ ...productData, product_id: id });
        }
      });
    }

    saveFavoritesToLocal(projectId, favorites);
    if (typeof callback === "function") callback(!isRemoving);
  }
  loadFavoriteNumber();
}

// Zjištění stavu – je produkt v oblíbených?
function checkFavoritesStatus(callback) {
  const projectId = getProjectId();
  const isDetailPage = $(".p-info-wrapper").length > 0;

  let productIds = [];

  if (isDetailPage) {
    const productCodes = getShoptetDataLayer("product").codes || [];
    productIds = productCodes.map((codeObj) => String(codeObj.code));
  } else {
  }

  if (!productIds.length) return;

  const applyStateToButtons = (favoriteIds) => {
    if (isDetailPage) {
      const $btn = $(".add-to-favorites");
      const isAnyFav = productIds.some((id) => favoriteIds.includes(id));
      $btn.text(isAnyFav ? "Odebrat z oblíbených" : "Přidat do oblíbených");
      $btn.toggleClass("in-favorites", isAnyFav);
    }
  };

  if (isUserLoggedIn()) {
    const userId = getShoptetDataLayer("customer").guid;

    $.post(
      "https://oblibene.shopcode.cz/favorite.php",
      {
        action: "list",
        user_id: userId,
        shop_id: projectId,
        product_ids: productIds,
      },
      function (data) {
        const favoriteIds = Array.isArray(data) ? data.map((f) => String(f.product_id)) : [];

        applyStateToButtons(favoriteIds);
        if (typeof callback === "function") callback(favoriteIds);
      },
    );
  } else {
    const localFavorites = getFavoritesFromLocal(projectId);
    const localIds = localFavorites.map((f) => String(f.product_id));
    applyStateToButtons(localIds);
    if (typeof callback === "function") callback(localIds);
  }
}

// Reakce na kliknutí na tlačítko
$(document).on("click", ".add-to-favorites", function () {
  const $btn = $(this);
  const productIds = JSON.parse($btn.attr("data-ids") || "[]");
  const isRemoving = $btn.hasClass("in-favorites");

  let $context;

  if ($(".p-info-wrapper").length) {
    $context = $(".p-info-wrapper");
    const availabilityData = getDetailAvailabilityData();
    var productData = {
      name: $context.find(".p-detail-inner-header h1").first().text().trim(),
      image: $(".p-image-wrapper .p-image").find("img").first().attr("src"),
      secondImage: normalizeOriginalImageSrc($(".p-thumbnails-inner .p-thumbnail:eq(1) img").attr("src")),
      price: $context.find(".price-final-holder").first().text().trim(),
      priceStandard: $(".p-image .price-standard span").first().text().trim() || "",
      url: document.location.href,
      hasVariants: $(".variant-list").length > 0,
      flags: $(".p-detail-info .flags-default").html() || "",
      flagsExtra: $(".p-image .flags.flags-extra").html() || "",
      variantDiscountText: $(".p-image .flag-discount .price-save .parameter-dependent.default-variant").first().text().trim() || "",
      product_id: $("input[name=productId]").val() || "",
      priceId: $("input[name=priceId]").val() || "",
      availabilityLabel: availabilityData.label,
      availabilityAmount: availabilityData.amount,
      availabilityColor: availabilityData.color,
    };
  }
  toggleFavoritesBatch(productIds, productData, isRemoving, function (newStatus) {
    $btn.text(newStatus ? "Odebrat z oblíbených" : "Přidat do oblíbených");
    $btn.toggleClass("in-favorites", newStatus);
    loadFavoriteNumber();
    if (window.location.pathname === favoriteUrl) {
      $btn.closest(".product").remove();
    }
  });
});

function loadFavoriteNumber(callback) {
  const projectId = getProjectId();

  function updateFavoriteIconCount(count) {
    const numericCount = Number(count) || 0;
    const $icon = $(".favorite_icon");
    const $container = $(".favorite");
    $icon.html(numericCount).attr("data-count", numericCount);

    if (numericCount > 0) {
      $icon.show();
      $container.addClass("has-favorites");
    } else {
      $icon.hide();
      $container.removeClass("has-favorites");
    }
  }

  if (isUserLoggedIn()) {
    const userId = getShoptetDataLayer("customer").guid;

    $.post(
      "https://oblibene.shopcode.cz/favorite.php",
      {
        action: "list",
        user_id: userId,
        shop_id: projectId,
      },
      function (data) {
        const seenUrls = new Set();

        data.forEach((product) => {
          try {
            const parsedData = JSON.parse(product.product_data);
            if (parsedData.url) {
              seenUrls.add(parsedData.url);
            }
          } catch (e) {
            console.warn("Chyba při parsování product_data:", e);
          }
        });
        updateFavoriteIconCount(seenUrls.size);
      },
    );
  } else {
    const favorites = getFavoritesFromLocal(projectId);
    const seenUrls = new Set();

    favorites.forEach((product) => {
      if (product.url) {
        seenUrls.add(product.url);
      }
    });
    updateFavoriteIconCount(seenUrls.size);
  }
}

function splitVariantDiscountText(text) {
  const normalized = (text || "").replace(/\s+/g, " ").trim();
  if (!normalized) return null;

  const value = normalized.replace(/^až\s*/i, "").trim();
  if (!value) return null;

  return {
    value,
  };
}

function getVariantDiscountText(product) {
  if (product.variantDiscountText) return product.variantDiscountText;
  if (!product.flagsExtra) return "";

  const $tmp = $("<div></div>").html(product.flagsExtra);
  return $tmp.find(".flag-discount .price-save .parameter-dependent.default-variant").first().text().trim() || "";
}

function getFlagsExtraHtml(product) {
  if (!product.hasVariants) return product.flagsExtra || "";

  const discountText = getVariantDiscountText(product);
  const parts = splitVariantDiscountText(discountText);
  if (!parts) return product.flagsExtra || "";

  return `<span class="flag flag-discount">až <span class="price-save">${parts.value}</span></span>`;
}

function getDetailAvailabilityData() {
  const $availability = $(".product-top .availability-value").first();
  if (!$availability.length) {
    return { label: "", amount: "", color: "" };
  }

  const $variantWithAmount = $availability
    .find(".parameter-dependent")
    .filter(function () {
      return $(this).find(".availability-amount").length > 0;
    })
    .first();
  const $source = $variantWithAmount.length ? $variantWithAmount : $availability;

  const $label = $source.find(".availability-label").first();
  const $amount = $source.find(".availability-amount").first();

  const rawLabel = ($label.text() || $source.text() || "").trim();
  const rawAmount = ($amount.text() || "").trim();
  const normalizedAmount = rawAmount.replace(/^\((.*)\)$/, "$1").trim();
  const color = ($label.attr("style") || $amount.attr("style") || "").match(/color\s*:\s*([^;]+)/i)?.[1]?.trim() || "";

  return {
    label: rawLabel,
    amount: normalizedAmount,
    color,
  };
}

function getAvailabilityHtml(product) {
  const label = (product.availabilityLabel || "").trim();
  const amount = (product.availabilityAmount || "").trim();
  const color = (product.availabilityColor || "").trim();

  if (!label && !amount) return "";

  const wrapperStyle = color ? ` style="color:${color}"` : "";
  const labelStyle = color ? ` style="color:${color}"` : "";

  return `<div class="availability"${wrapperStyle}><span${labelStyle}>${label}</span>${amount ? `<span class="availability-amount" data-testid="numberAvailabilityAmount">${amount}</span>` : ""}</div>`;
}

function renderFavorites(favorites) {
  const $container = $('<div class="favorites-list products-block products"></div>');
  $('#content div[itemprop="about"]').append($container);

  const seenUrls = new Set();
  const uniqueFavorites = [];

  favorites.forEach((product) => {
    if (!seenUrls.has(product.url)) {
      seenUrls.add(product.url);
      uniqueFavorites.push(product);
    }
  });

  if (!uniqueFavorites.length) {
    $container.html('<p class="h4">Nemáte žádné oblíbené produkty.</p>');
    $container.addClass("empty");
    return;
  }

  uniqueFavorites.forEach((product) => {
    const $item = $(`
      <div class="product lastWiew">
        <div class="p" data-micro="product" data-testid="productItem">
          <a href="${product.url}" class="image">
            <img src="${product.image}" data-src="${product.secondImage || ""}" alt="${product.name}" loading="lazy">
              <div class="flags flags-default">${product.flags || ""}</div>
              <div class="flags flags-extra">${getFlagsExtraHtml(product)}</div>
          </a>
          <div class="p-in">
            <div class="p-in-in">
              <a href="${product.url}" class="name" data-micro="url">
                <span data-micro="name" data-testid="productCardName">${product.name}</span>
              </a>
              <div class="ratings-wrapper">${getAvailabilityHtml(product)}</div>
            </div>
            <div class="p-bottom single-button no-buttons">
              <div data-micro="offer">
                <div class="prices">  ${product.priceStandard ? `<span class="price-standard"><span>${product.priceStandard}</span></span>` : ""}
               
                  <span class="price price-final"><strong>${product.price || ""}</strong></span>
                </div>
                <div class="p-tools">
                  ${
                    product.hasVariants
                      ? `<a href="${product.url}" class="btn btn-primary" aria-hidden="true" tabindex="0">Detail produktu</a>`
                      : `<form action="/action/Cart/addCartItem/" method="post" class="pr-action csrf-enabled">
                    <input type="hidden" name="language" value="cs" tabindex="0">
                    <input type="hidden" name="productId" value="${product.product_id}" tabindex="0">
                        <input type="hidden" name="priceId" value="${product.priceId}" tabindex="0">
                    <input type="hidden" name="amount" value="1" autocomplete="off" tabindex="0">
                    <button type="submit" class="btn btn-cart add-to-cart-button">
                      <span>Do košíku</span>
                    </button>
                  </form>`
                  }
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    `);

    $container.append($item);
  });
}

function loadFavorites(callback) {
  const projectId = getProjectId();

  if (isUserLoggedIn()) {
    const userId = getShoptetDataLayer("customer").guid;
    $.post(
      "https://oblibene.shopcode.cz/favorite.php",
      {
        action: "list",
        user_id: userId,
        shop_id: projectId,
      },
      function (data) {
        const favorites = [];

        data.forEach((product) => {
          try {
            const parsedData = JSON.parse(product.product_data);
            product = { ...product, ...parsedData };
          } catch (e) {
            console.error("Chyba při parsování product_data:", e);
          }
          favorites.push(product);
        });

        renderFavorites(favorites);
        if (typeof callback === "function") callback(favorites);
      },
    );
  } else {
    const localFavorites = getFavoritesFromLocal(projectId);
    renderFavorites(localFavorites);
    if (typeof callback === "function") callback(localFavorites);
  }
}

// Načíst stavy po načtení stránky
$(document).ready(function () {
  $("header#header .responsive-tools").append('<a href="' + favoriteUrl + '" class="favorite"><i class="favorite_icon" data-count="0">0</i></a>');
  loadFavoriteNumber();
  checkFavoritesStatus();

  if (window.location.pathname === favoriteUrl) {
    $("main#content div.content-inner").attr("style", "max-width:100%;width:100%;");
    loadFavorites();
  }
});
